<template>
  <component
    :is="activeComponent"
    :key="isRbc ? 'rbc' : 'wbc'"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useConfigStore } from '@/store';
import { useConstants } from '@/composables/useAppGlobals';
import RBCCell from './RBCCell.vue';
import WBCCell from './WBCCell.vue';

const config = useConfigStore();
const $const = useConstants();

const isRbc = computed(() => Boolean(config.slideInfo[$const.SLIDE_KEYS.IS_RBC]));
const activeComponent = computed(() => (isRbc.value ? RBCCell : WBCCell));
</script>
